function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.9 5.3h-8.1c-1.2 0-2.3-.5-3.1-1.3-.9-.9-2-1.4-3.2-1.4H2.9C1.3 2.6 0 4 0 5.6v12.7c0 1.7 1.4 3 3.1 3h17.8c1.7 0 3.1-1.3 3.1-3v-10c0-1.7-1.4-3-3.1-3z",
  fill: "#231F20"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;